import React, { useCallback } from 'react';
import Spinner, { SpinnerColor } from '../../Spinner';
import { MFA_STEPS_MAP } from '../helpers/constants';
import { MfaIntro } from './mfa-intro';
import ResendVerification from './ResendMfa';
import TempLocked from './TempLocked';
import TookABreak from './tookABreak';

interface IStepSwitch {
    activeStep?: number,
}
export const StepSwitch = ({ activeStep }: IStepSwitch) => {
  const getActiveStep = useCallback(() => {
    switch (activeStep) {
      case MFA_STEPS_MAP.LOADER:
        return <Spinner spinnerColor={SpinnerColor.Blue} height='50px' width='50px' />;
      case MFA_STEPS_MAP.INTRO:
        return <MfaIntro />;
      case MFA_STEPS_MAP.RESEND:
        return <ResendVerification />;
      case MFA_STEPS_MAP.TAKE_5:
        return <TempLocked shouldLogOutOnBack />;
      case MFA_STEPS_MAP.TOOK_A_BREAK:
        return <TookABreak />;
      default:
        return <div>Error occurs</div>;
    }
  }, [activeStep]);
  return (
    <>
      {getActiveStep()}
    </>
  );
};
